import React, { FC } from 'react';

import { FILTERS, TFilterField } from '../../constants/filters';
import { EDealType, EOfferType } from '../../utils/jsonQuery';
import { FiltersSearchButtonsContainer } from '../../containers/FiltersSearchButtonsContainer';
import styles from './Filters.css';

export interface IFiltersProps {
  items: TFilterField[];
  dealType: EDealType;
  offerType: EOfferType;
}

export const Filters: FC<IFiltersProps> = ({ items, dealType, offerType }) => {
  return (
    <>
      <div className={styles['container']} data-mark="Filters">
        <div className={styles['wrapper']}>
          {items.map(filterName => {
            const filter = FILTERS[filterName];
            const { component: Component } = filter;

            return <Component key={`filter_${filterName}`} dealType={dealType} offerType={offerType} />;
          })}
        </div>
      </div>
      <div className={styles['buttons']}>
        <FiltersSearchButtonsContainer />
      </div>
    </>
  );
};
